import { render, staticRenderFns } from "./FileDragArea.vue?vue&type=template&id=e9284ea8&scoped=true&"
import script from "./FileDragArea.vue?vue&type=script&lang=js&"
export * from "./FileDragArea.vue?vue&type=script&lang=js&"
import style0 from "./FileDragArea.vue?vue&type=style&index=0&id=e9284ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9284ea8",
  null
  
)

export default component.exports